<template>
  <el-card>
    <el-form label-width="100px" label-position="left">
      <el-form-item label="物料名称" prop="materialName">
        {{ formData.materialName }}
      </el-form-item>
      <el-form-item label="物料编码" prop="materialCode">
        {{ formData.materialCode }}
      </el-form-item>
      <el-form-item label="物料分类" prop="materialTypeId">
        {{ formData.materialTypeName }}
      </el-form-item>
      <el-form-item label="单位" prop="company">
        {{ formData.company }}
      </el-form-item>
      <el-form-item label="规格" prop="specifications">
        {{ formData.specifications }}
      </el-form-item>
      <el-form-item label="供应商名称" prop="supplierName">
        {{ formData.supplierName }}
      </el-form-item>
      <el-form-item label="状态" prop="isStop">
        {{ formData.isStop === 0 ? '启用' : '禁用' }}
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        materialName: '', // 物料名称
        materialCode: '', // 物料编码
        materialTypeId: '', // 物料分类
        materialTypeName: '',
        company: '', // 单位
        specifications: '', // 规格
        isStop: null // 状态1启用2禁用
      }
    }
  },
  computed: {
    materialId() {
      return this.$route.query.materialId
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$axios.get(this.$apis.material.selectYhMaterialByMaterialId, {
        materialId: this.materialId
      }).then(res => {
        this.formData = res
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>